module.exports = __webpack_public_path__ + "img/4.8fe1c230.png";